import script from "./OtherIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherIncome.vue?vue&type=script&setup=true&lang=js"

import "./OtherIncome.vue?vue&type=style&index=0&id=7dabfdc3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dabfdc3"]])

export default __exports__